import axios from "axios";

import { FARMING_OPERATIONS_API_URL } from "../config/apiConfig";

/**
 * Offres de travaux champêtres publiées depuis agro-entreprise-page, et candidatures.
 *
 *   Navigateur :3000 → Gateway :8080 → agri-farming-operations-platform :1996
 *   GET  /public/job-offers?country=TG&page=&size=&q=   public, sans JWT (q : recherche texte)
 *   POST /job-offers/{id}/applications               particulier connecté (rôle INDIVIDUAL)
 *   GET  /me/job-applications                        particulier connecté
 *
 * La liste publique n'envoie jamais de JWT (un jeton expiré la ferait échouer
 * en 401 au lieu d'afficher les offres). L'identité du candidat (nom, email,
 * téléphone du compte) est lue côté backend depuis son compte, jamais envoyée ici.
 */
const api = axios.create({
    baseURL: FARMING_OPERATIONS_API_URL,
    timeout: 20000
});

const authorized = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

/** @param {{country: string, page?: number, size?: number, q?: string}} query  q : recherche texte (barre de recherche) */
export const listPublicJobOffers = async ({ country, page = 0, size = 100, q }) => {
    const { data } = await api.get("/public/job-offers", {
        params: { country, page, size, q }
    });
    return {
        items: data.items || [],
        total: data.total ?? 0,
        currency: data.currency || null
    };
};

/** @param {{availableFrom?: string, message?: string, telephone?: string}} application */
export const applyToJobOffer = async (token, offerId, application) => {
    const { data } = await api.post(`/job-offers/${offerId}/applications`, application, authorized(token));
    return data;
};

export const listMyJobApplications = async (token) => {
    const { data } = await api.get("/me/job-applications", authorized(token));
    return data || [];
};

const fieldWorkService = { listPublicJobOffers, applyToJobOffer, listMyJobApplications };

export default fieldWorkService;
